import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class ServiceTypeGroupItem {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;
  @Expose()
  @IsOptional()
  @IsNumber()
  documentTypeId!: null | number;
  @Expose()
  @IsString()
  vat!: string;
  @Expose()
  @IsOptional()
  @IsString()
  code!: string | null;
  @Expose()
  @IsString()
  documentType!: string;
  @Expose()
  @IsBoolean()
  isAssignedToService!: boolean;
}

export class ServiceTypeGroupItems extends GenericTableResponse<ServiceTypeGroupItem> {
  @Expose()
  @Type(() => ServiceTypeGroupItem)
  @IsArray()
  @ValidateNested()
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  items!: Array<ServiceTypeGroupItem>;
}
